<template>
  <validation-observer ref="dateForm">
    <div>
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <label  :class="{' col-md-3 col-xs-4' : isInquiry , 'attribute-label' : !isInquiry}" :for="id">
          {{ question.question_text }}
        </label>
                <validation-provider :rules="question.mandatory ? 'required' : ''" v-slot="{errors}">
          <div :class="{' col-md-9 col-xs-8' : isInquiry}">
                        <div class="date-attribute input-group" >
                            <input ref="date" :id="id" :name="name" class="form-control input-group-new-design"
                                   placeholder="" v-model="question.value" >
              <input type="hidden" :value="id" name="questions[]">

              <span class="input-group-addon input-group-addon-new-design"><i
                                class="fa fa-calendar"></i></span>
            </div>
                        <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>

                        <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
          </div>
        </validation-provider>
      </div>
    </div>
  </validation-observer>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormDate",
	components: {
		ValidationObserver,
		ValidationProvider
	},
	props: {
		value: {
			type: Object,
            default() {
				return {}
			}
		},
        dateFormat:{
			required: true,
			type: String
		},
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
	},
    data() {
		return {
			question: {
				...this.value,
				value: ''
			},
			input: null
		}
	},
	computed: {
		/**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
			}
            return `question_${this.question.update_booking_question_id}_0`;

		},
		/**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
			}
            return `question_${this.question.update_booking_question_id}_0`;
		}
	},
	methods: {
        changeDate(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry(this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
			}
		},
        addDatePickerEventListener() {
			this.input.on('changeDate', (event) => {

				this.question.value = event.format()
                this.changeDate();
			})
		},
        initiateDatePicker() {
            this.input = $(this.$refs['date']).datepicker({
                todayBtn: "linked",
				todayHighlight: true,
				keyboardNavigation: false,
				forceParse: false,
				calendarWeeks: true,
				autoclose: true,
				format: this.dateFormat || 'dd/mm/yyyy'
			})
            this.addDatePickerEventListener();
		},

        setValue(date) {
            if(date){
                    this.question.value = date;
				// this.input.datepicker('setDate', this.question.value)
			}
		},
        addEventListeners() {
			EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.dateForm){
                    let validated = await this.$refs.dateForm.validate();
					verify(validated)
				}

			})

		},
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.initiateDatePicker();
        })
        this.setValue(this.question.answer_text_names)
        this.addEventListeners()
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
		}
    },
    destroyed() {
        this.removeEventListeners();
	}
}
</script>

<style scoped>
.p-0-1{
    padding:0px 1px;
}

@media screen and (min-width: 768px) and (max-width: 1440px) {

    .change-form-list-in-inquiry .form-control{
        width: 100% !important;
    }
}

@media screen and (min-width: 1px) and (max-width: 428px) {
    /*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        width: 57%;
    }

}

@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        /*margin-left: 17px !important;*/
    }

}

</style>
